import React, { useEffect, useMemo } from 'react'
import injectSheet from 'react-jss/lib/injectSheet'
import { accessibilityColors } from '../../colors'
import shuffle from 'lodash/shuffle'
import THEME from 'pobble-components/dist/theme'

const { COLORS } = THEME

const wordBankThumbnail = {
  container: {
    height: '100%',
    width: '100%',
    padding: '1em',
    overflow: 'hidden',
    color: COLORS.TEXT.OFF_BLACK.NORMAL
  },
  categories: {
    textAlignLast: 'center',
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoFlow: 'column',
    gridGap: '.6em',
    listStyle: 'none',
    padding: '0',
    margin: '0',
    fontSize: '.5em',
    lineHeight: '1.5'
  },
  words: {
    listStyle: 'none',
    margin: '0',
    padding: '0',
    marginTop: '.3em'
  },
  shuffledWords: {
    fontSize: '.5em',
    textAlign: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    listStyle: 'none',
    margin: '0',
    padding: '0',
    '& > li': {
      margin: '.6em',
      minWidth: '8em'
    }
  },
  word: {
    borderRadius: '.3em',
    color: '#fff',
    fontWeight: 'bold',
    marginBottom: '.6em',
    padding: '.25em'
  }
}

const WordBankSlideThumbnail = injectSheet(wordBankThumbnail)(
  ({ classes, presentation, slide, onLoad }) => {
    useEffect(() => {
      onLoad()
    })

    const bank = useMemo(() => {
      if (slide.layout !== 'column') return null
      return slide.bank.map(category => {
        return {
          ...category,
          words: category.words.split(',').filter(word => word.trim())
        }
      })
    }, [slide.bank])

    const shuffledWords = useMemo(() => {
      if (slide.layout !== 'random') return null
      const words = []
      slide.bank.forEach(category => {
        category.words
          .split(',')
          .filter(word => word.trim())
          .forEach(word =>
            words.push({
              word,
              category
            })
          )
      })
      return shuffle(words)
    }, [slide])

    return (
      <div
        className={classes.container}
        style={{
          backgroundColor: accessibilityColors[presentation.accessibility_color]
        }}>
        {bank && (
          <ul className={classes.categories}>
            {bank.map((category, index) => {
              return (
                <li key={index}>
                  {category.title}
                  <ul className={classes.words}>
                    {category.words.map((word, index) => {
                      return (
                        <li
                          key={index}
                          className={classes.word}
                          style={{ backgroundColor: category.color }}>
                          {word}
                        </li>
                      )
                    })}
                  </ul>
                </li>
              )
            })}
          </ul>
        )}
        {shuffledWords && (
          <ul className={classes.shuffledWords}>
            {shuffledWords.map((word, index) => {
              return (
                <li
                  key={index}
                  className={classes.word}
                  style={{ backgroundColor: word.category.color }}>
                  {word.word}
                </li>
              )
            })}
          </ul>
        )}
      </div>
    )
  }
)

export default WordBankSlideThumbnail
